/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upgrade_Alert_UpdateInputs */

const en_mobile_upgrade_alert_update = /** @type {(inputs: Mobile_Upgrade_Alert_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const es_mobile_upgrade_alert_update = /** @type {(inputs: Mobile_Upgrade_Alert_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Mobile_Upgrade_Alert_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upgrade_alert_update = /** @type {((inputs?: Mobile_Upgrade_Alert_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upgrade_Alert_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upgrade_alert_update(inputs)
	return en_mobile_upgrade_alert_update(inputs)
});